import { EmailIcon, SettingsIcon, ShieldIcon } from "@moznsystems/mozn-ui";
import {
	ArrowheadDownIcon,
	LogoutOutlineIcon,
	useClickAway,
} from "@rageeb/frontend-lib";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { logout } from "@/auth";
import { ACCOUNT_SETTINGS_ROUTE } from "@/constants/routes";
import { LocalizedNavLink } from "@/router/localized-link";
import { requiresConsent } from "@/services/consent";
import { useAuthStore } from "@/store/authStore";
import { useCookieConsentStore } from "@/store/cookieConsentStore";
import "./AccountPreview.scss";

const AccountPreview: FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { setUser, setIsGlobalLoader, user } = useAuthStore();
	const { t } = useTranslation("layout");
	const openCookiePreferences = useCookieConsentStore(
		(state) => state.openPreferences,
	);

	const ref = useClickAway<HTMLDivElement>(() => {
		setIsOpen(false);
	});

	const handleOpen = () => {
		setIsOpen(!isOpen);
	};

	const onLogout = (e: React.MouseEvent<HTMLElement>) => {
		try {
			e.preventDefault();
			setIsGlobalLoader(true);
			setTimeout(async () => {
				await logout();
				setUser(null);
				setIsGlobalLoader(false);
			}, 1000);
		} catch {
			setIsGlobalLoader(false);
		}
	};

	return (
		<div className="account-preview" ref={ref}>
			<div
				className="account-preview--dropdown"
				onClick={handleOpen}
				id="account-preview--dropdown"
			>
				<span className="text">{`${user?.first_name} ${user?.last_name}`}</span>
				<ArrowheadDownIcon />
			</div>
			{isOpen && (
				<div
					className="account-preview--links"
					onClick={() => setIsOpen(false)}
				>
					<LocalizedNavLink to={ACCOUNT_SETTINGS_ROUTE} className="item-link">
						<SettingsIcon version="2" />
						{t("account.settings")}
					</LocalizedNavLink>
					<div className="separator"></div>

					<a
						href="mailto:support_focal@mozn.sa"
						rel="noreferrer"
						target="_blank"
						className="item-link"
					>
						<EmailIcon />
						{t("account.email_us")}
					</a>

					{requiresConsent() ? (
						<>
							<div className="separator"></div>
							<button
								type="button"
								className="item-link border-0 bg-transparent p-0"
								onClick={openCookiePreferences}
								data-testid="account-cookie-preferences"
							>
								<ShieldIcon />
								{t("account.cookie_preferences")}
							</button>
						</>
					) : null}

					<div className="separator"></div>

					<div className="item-link" onClick={onLogout}>
						<LogoutOutlineIcon />
						{t("account.logout")}
					</div>
				</div>
			)}
		</div>
	);
};

export { AccountPreview };
